import { api } from '../../utils/apiClient';

const fetchUserRoles = async () => {
    const response = await api.get('/userroles')
    return response.data
}

const fetchUserPrivileges = async () => {
    try {
        const response = await api.get('/userprivileges')
        // If response contains error, return empty array
        if (response.data.error) {
            console.log('Privileges fetch error:', response.data.error);
            return [];
        }
        // Ensure we return an array
        return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        console.error('Failed to fetch user privileges:', error);
        return [];
    }
}

const fetchUserRolesPrivileges = async () => {
    const roles = await fetchUserRoles();
    const privileges = await fetchUserPrivileges();
    return {roles, privileges}
}

export default fetchUserRolesPrivileges